import { Component, OnInit } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-terms-of-use-dialog',
  templateUrl: './terms-of-use-dialog.component.html',
  styleUrls: ['./terms-of-use-dialog.component.scss']
})
export class TermsOfUseDialogComponent implements OnInit {
  translateLanguage: string;

  constructor(public dialogRef: MatDialogRef<TermsOfUseDialogComponent>) { 
    this.translateLanguage = navigator.language.split('-')[0];
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /var/www/hqsol/hqsol-live/app/src/app/components/terms-of-use-dialog/terms-of-use-dialog.component.ts